import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { UserType } from "muminsmart-utils";
import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";
import SellerLayoutContent from "@/app/seller/SellerLayoutContent";

export default function SellerLayoutRoute() {
  const { data: session } = useAuth();

  return (
    <div className={styles.homeLayout} style={layoutBackgrounds.home}>
      <main>
        <SellerLayoutContent
          sessionUserType={session?.user?.type as UserType | undefined}
        >
          <Outlet />
        </SellerLayoutContent>
      </main>
    </div>
  );
}
